import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getExternalInvoiceFile = payload =>
  call(websocketFetch, 'get_external_invoice_file', payload);
